module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"listHeader":"Jeg vil lære ...","signIn":"Logg inn","switchBaseLanguage":"Change to English base language"},"en":{"listHeader":"I want to learn ...","signIn":"Sign in","switchBaseLanguage":"Endre til norsk base-språk"}}')
  delete Component.options._Ctor
}
